export default __webpack_public_path__ + "static/media/ca.efb35652.svg";